module.exports = __webpack_public_path__ + "media/images/sorting_hand_gesture-de9a757c029f5551770dc5baccce8bff.svg";